var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{class:[
    'main-layout p-0',
    {
      'h-100': _vm.isFullScreen
    }
  ],attrs:{"fluid":""}},[_c('header-section'),_vm._t("default"),(!_vm.hideFooter)?_c('footer-section'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }